import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { userProfileService } from "../service/userProfile/userProfile.service";
import { AddAddressModal } from "../components/modals/AddAddressModal";
import { UpdateAddressModal } from "../components/modals/UpdateAddressModal";
import { AddressList } from "../components/address/AddressList";
import DynamicAlert from "../helpers/dynamicAlert";

export const AddressesPage = (props) => {
    const { alert, showAlert } = props;

    const [customerId, setCustomerId] = useState(null);
    const [show, setShow] = useState(false);
    const [addressUpdateShow, setAddressUpdateShow] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [addressDetails, setAddressDetails] = useState({});
    const [processing, setProcessing] = useState(false);


    const handleClose = useCallback(() => setShow(false), []);
    const handleShow = useCallback(() => setShow(true), []);

    const addressUpdateHandleClose = useCallback(
        () => setAddressUpdateShow(false),
        []
    );

    const addressUpdatehandleShow = useCallback(
        (id) => () => {
            const selected = addresses.find((a) => a.id === id);
            setAddressDetails(selected || {});
            setAddressUpdateShow(true);
            setCustomerId(id);
        },
        [addresses]
    );

    useEffect(() => {
        if (!props?.email) return;

        let isMounted = true;

        const loadAddresses = async () => {
            try {
                setAddressDetails({ customerId: props.email });

                await userProfileService.syncAddress();

                const data = await userProfileService.getCustomerAddress();

                if (isMounted && Array.isArray(data)) {
                    setAddresses(data);
                }
            } catch (error) {
                console.error("Address fetch failed:", error);
            }
        };

        loadAddresses();

        return () => {
            isMounted = false;
        };
    }, [props.email]);

    const addressHandleChange = useCallback((event) => {
        const { name, value } = event.target;

        setAddressDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    }, []);

    const addAddress = useCallback(
        (event) => {
            event.preventDefault();
            setProcessing(true);

            userProfileService
                .saveAddress(addressDetails)
                .then((data) => {
                    if (data?.success) {
                        setShow(false);

                        setAddresses((prev) => [
                            { ...addressDetails, id: data.id },
                            ...prev,
                        ]);

                        showAlert("Successfully added new address", "success");
                    } else {
                        showAlert("Invalid Inputs", "warning");
                    }
                })
                .finally(() => setProcessing(false));
        },
        [addressDetails, showAlert]
    );

    const updateAddress = useCallback(
        (id) => () => {
            setProcessing(true);

            userProfileService
                .updateAddress(addressDetails, id)
                .then((data) => {
                    if (data?.success) {
                        setAddressUpdateShow(false);

                        setAddresses((prev) =>
                            prev.map((addr) =>
                                addr.id === id ? addressDetails : addr
                            )
                        );

                        showAlert("Successfully updated address", "success");
                    } else {
                        showAlert("Invalid Inputs", "warning");
                    }
                })
                .finally(() => setProcessing(false));
        },
        [addressDetails, showAlert]
    );

    const deleteItem = useCallback(
        (index, id) => () => {
            userProfileService.deleteAddress(id).then((data) => {
                if (data?.success) {
                    setAddresses((prev) =>
                        prev.filter((_, i) => i !== index)
                    );

                    showAlert("Successfully Deleted", "success");
                } else {
                    showAlert("Something went wrong", "warning");
                }
            });
        },
        [showAlert]
    );

    const addressRequest = {
        addresses,
        addressUpdatehandleShow,
        deleteItem,
    };

    const addAddressDetails = {
        show,
        handleClose,
        addressHandleChange,
        addAddress,
        alert,
        processing,
    };

    const updateAddressDetails = {
        addressUpdateShow,
        addressUpdateHandleClose,
        addressHandleChange,
        updateAddress,
        addressDetails,
        customerId,
        alert,
        processing,
    };

    return (
        <div className="mfa-body">
            <div className="mfa-container">
                <div className="text-center m-6-auto">
                    <DynamicAlert alert={alert} />
                    <div className="p-1 py-2">
                        <div className="text-center m-6-auto section-title">
                            <h4>Address</h4>
                        </div>

                        <p>Add and delete your address for quick checkout</p>

                        <AddressList {...addressRequest} />

                        <button
                            style={{ width: "100%", borderRadius: "0" }}
                            className="btn btn-outline-success"
                            type="button"
                            onClick={handleShow}
                        >
                            + Add A New Address
                        </button>

                        <AddAddressModal {...addAddressDetails} />
                        <UpdateAddressModal {...updateAddressDetails} />
                    </div>
                </div>
            </div>
        </div>
    );
};